import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//     apiKey: "AIzaSyA3dZ8pRI_zdp8Mu-6ah62WjgCECRfuHOc",
//     authDomain: "admininboxrealtime.firebaseapp.com",
//     projectId: "admininboxrealtime",
//     storageBucket: "admininboxrealtime.firebasestorage.app",
//     messagingSenderId: "301908728939",
//     appId: "1:301908728939:web:83869193c81b577f84a52e",
//     measurementId: "G-12ZSGBKHQ1"
// };

const firebaseConfig = {
    apiKey: "AIzaSyA3dZ8pRI_zdp8Mu-6ah62WjgCECRfuHOc",
    authDomain: "admininboxrealtime.firebaseapp.com",
    projectId: "admininboxrealtime",
    storageBucket: "admininboxrealtime.firebasestorage.app",
    messagingSenderId: "301908728939",
    appId: "1:301908728939:web:83869193c81b577f84a52e",
    measurementId: "G-12ZSGBKHQ1"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };